import {
  ForgetPasswordEmailRequest,
  ForceUpdatePasswordEmailRequest,
  IdPasswordSignInFormEntity,
  IdPasswordSignInRequest,
  PasswordForgetFormEntity,
  PasswordForceUpdateFormEntity,
  UpdateInitialPasswordFormEntity,
  UpdateInitialPasswordRequest,
  UpdatePasswordFormEntity,
  UpdatePasswordRequest,
  CheckLoginSettingResponse,
  LoginFormSettingEntity,
} from 'src/types'

type ToLoginFormSettingEntityInput = {
  response: CheckLoginSettingResponse
  email: string
}

export const AuthTranslator = {
  toLoginFormSettingEntity: (input: ToLoginFormSettingEntityInput): LoginFormSettingEntity => {
    const { response, email } = input
    return {
      ...response,
      email,
      idpAuthURL: response.idpAuthURL || undefined,
    }
  },

  toIdPassSignInRequest: (formEntity: IdPasswordSignInFormEntity): IdPasswordSignInRequest => {
    return { ...formEntity }
  },

  toUpdateInitialPasswordRequest: (
    formEntity: UpdateInitialPasswordFormEntity
  ): UpdateInitialPasswordRequest => {
    return {
      name: formEntity.name,
      password: formEntity.newPassword,
    }
  },

  toForgetPasswordEmailRequest: (
    formEntity: PasswordForgetFormEntity
  ): ForgetPasswordEmailRequest => {
    return { email: formEntity.email }
  },

  toForceUpdatePasswordEmailRequest: (
    formEntity: PasswordForceUpdateFormEntity
  ): ForceUpdatePasswordEmailRequest => {
    return { password: formEntity.password, sendEmail: formEntity.isSendEmail }
  },

  toUpdatePasswordRequest: (formEntity: UpdatePasswordFormEntity): UpdatePasswordRequest => {
    return {
      oldPassword: formEntity.oldPassword,
      newPassword: formEntity.newPassword,
    }
  },
} as const
